import { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";
import QuestionNavPanel from "./QuestionNavPanel";

export default function MobileNavDrawer({
  isOpen,
  onClose,
  questions,
  currentIndex,
  answeredMap,
  testSections,
  flaggedSet,
  runByIndex,
  onNavigate,
}) {
  const { t } = useTranslation();

  const handleNavigate = (index) => {
    onNavigate(index);
    onClose();
  };

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-40" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-slate-900/50" />
        </Transition.Child>

        <div className="fixed inset-0 flex justify-end">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="translate-x-full"
            enterTo="translate-x-0"
            leave="ease-in duration-200"
            leaveFrom="translate-x-0"
            leaveTo="translate-x-full"
          >
            <Dialog.Panel className="flex h-full w-80 max-w-[85vw] flex-col bg-white shadow-2xl ring-1 ring-slate-900/5">
              <div className="flex items-center justify-between border-b border-slate-200 px-4 py-3">
                <Dialog.Title className="text-sm font-semibold text-slate-900">
                  {t("exam_taking.question_nav")}
                </Dialog.Title>
                <button
                  type="button"
                  onClick={onClose}
                  className="rounded-lg p-2 text-slate-400 transition duration-200 hover:bg-slate-100 hover:text-slate-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
                  aria-label={t("buttons.close")}
                >
                  <XMarkIcon className="h-5 w-5" />
                </button>
              </div>
              <div className="flex-1 overflow-y-auto p-5">
                <QuestionNavPanel
                  questions={questions}
                  currentIndex={currentIndex}
                  answeredMap={answeredMap}
                  testSections={testSections}
                  flaggedSet={flaggedSet}
                  runByIndex={runByIndex}
                  onNavigate={handleNavigate}
                />
              </div>
            </Dialog.Panel>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
}
